.faq {
  display: flex;
  flex-direction: column;
  padding: 2rem 3rem;
  border-radius: 1rem;
  margin: 3rem 2.5rem;
  background-color: var(--deposit-withdraw-bg-color);
}

.titleText {
  margin: 1rem 0;
}

.header {
  display: flex;
  flex-direction: column;
}

.backButton {
  margin-right: 0.5rem;
}

.headerText {
  display: flex;
}

.queryClusters {
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
}
